import defaultFilter from "./defaultFilter";

export default defaultFilter;
